import React, { useState } from 'react';
import {
    NameContainer,
    RoleContainer,
    DistContainer,
    DistrictContainer,
    UserProxyListContainer,
    ProxyListContainerWrapper,
} from './userProxyPanel.styled';
import { useSelector } from 'react-redux';
import InitiatePlay from 'src/assets/images/initiate-play.svg';
import DisabledInitiate from 'src/assets/images/Path - play.svg';
import { useTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import InitiateProxy from 'src/pages/more/pages/proxies/initiateProxy';
import {
    ButtonLabel,
    EditContainer,
    EditIconContainer,
    StyledImage,
    PopupContainer,
    EditContainerMob,
    EditIconContainerMob,
    ButtonLabelMob,
    StyledImageMob,
} from 'src/pages/more/pages/proxies/proxiesTab/proxiesTab1.styled';
import moment from 'moment';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import { checkImpersonationActive, checkProxyActive } from 'src/utils/util';

const UserProxyList = (props) => {
    const { t } = useTranslation();
    const [showInitiateProxy, setshowInitiateProxy] = useState(false);
    const [proxyData, setproxyData] = useState({});
    const [initiateProxy] = useState(false);
    const proxyList = useSelector(
        (state) =>
            state.ProxyReducer.proxyList &&
            state.ProxyReducer.proxyList.proxyRecordsForUser
    );
    const closeInitiateProxy = () => {
        setproxyData({});
        setshowInitiateProxy(false);
    };
    const todayDate = moment(new Date()).format('YYYY-MM-DD[T]HH:mm:ss[Z]');
    const openInitiateProxy = (listData) => {
        const fromDate = listData.fromDate;
        if (
            moment(fromDate).isAfter(todayDate) ||
            checkProxyActive() ||
            checkImpersonationActive()
        ) {
            setshowInitiateProxy(false);
        } else {
            sessionStorage.setItem(
                'ProxyUser',
                listData.proxyEmployee && listData.proxyEmployee.displayName
            );
            sessionStorage.setItem(
                'ProxyDistrict',
                listData && listData.address && listData.address[0].district
            );
            setproxyData(listData);
            setshowInitiateProxy(true);
        }
    };
    return (
        <UserProxyListContainer
            showDiv={proxyList && proxyList.length > 0 ? true : false}
        >
            {proxyList &&
                proxyList.map((listData, index) => {
                    const dist =
                        listData.address &&
                        listData.address
                            .map((item) => item.district)
                            .filter(
                                (value, index, self) =>
                                    self.indexOf(value) === index
                            );

                    if (
                        moment(listData.fromDate).isAfter(todayDate) ||
                        checkProxyActive()
                    ) {
                        return null;
                    } else
                        return (
                            <ProxyListContainerWrapper>
                                <Grid
                                    container
                                    direction="row"
                                    key={index}
                                    style={{ margin: '15px 0px 10px 0px' }}
                                >
                                    <Grid
                                        item
                                        xs={6}
                                        sm={6}
                                        md={6}
                                        lg={6}
                                        xl={6}
                                        mobile={6}
                                    >
                                        <NameContainer>
                                            {listData.proxyEmployee.displayName}
                                        </NameContainer>
                                        <RoleContainer>
                                            {
                                                listData.proxyEmployee
                                                    .employeeRole
                                            }
                                        </RoleContainer>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={6}
                                        sm={6}
                                        md={6}
                                        lg={6}
                                        xl={6}
                                        mobile={6}
                                    >
                                        <EditIconContainer
                                            backColor={
                                                moment(
                                                    listData.fromDate
                                                ).isAfter(todayDate) ||
                                                checkProxyActive() ||
                                                checkImpersonationActive()
                                                    ? '#9f9f9f'
                                                    : '#ffffff'
                                            }
                                        >
                                            <EditContainer
                                                labelColor={
                                                    moment(
                                                        listData.fromDate
                                                    ).isAfter(todayDate) ||
                                                    checkProxyActive() ||
                                                    checkImpersonationActive()
                                                        ? 'white'
                                                        : '#1010eb'
                                                }
                                            >
                                                <a
                                                    style={{ display: 'flex' }}
                                                    onClick={() =>
                                                        openInitiateProxy(
                                                            listData
                                                        )
                                                    }
                                                >
                                                    <StyledImage
                                                        src={
                                                            moment(
                                                                listData.fromDate
                                                            ).isAfter(
                                                                todayDate
                                                            ) ||
                                                            checkProxyActive() ||
                                                            checkImpersonationActive()
                                                                ? DisabledInitiate
                                                                : InitiatePlay
                                                        }
                                                        width="auto"
                                                        height="auto"
                                                        cursor={
                                                            !checkProxyActive() &&
                                                            !checkImpersonationActive()
                                                                ? 'pointer'
                                                                : 'default'
                                                        }
                                                    />
                                                    <ButtonLabel
                                                        labelColor={
                                                            moment(
                                                                listData.fromDate
                                                            ).isAfter(
                                                                todayDate
                                                            ) ||
                                                            checkProxyActive() ||
                                                            checkImpersonationActive()
                                                                ? 'white'
                                                                : '#1010eb'
                                                        }
                                                        cursor={
                                                            !checkProxyActive() &&
                                                            !checkImpersonationActive()
                                                                ? 'pointer'
                                                                : 'default'
                                                        }
                                                    >
                                                        {t('proxies.initiate')}
                                                    </ButtonLabel>
                                                </a>
                                            </EditContainer>
                                        </EditIconContainer>
                                        <EditIconContainerMob
                                            backColor={
                                                moment(
                                                    listData.fromDate
                                                ).isAfter(todayDate) ||
                                                checkProxyActive() ||
                                                checkImpersonationActive()
                                                    ? '#9f9f9f'
                                                    : '#ffffff'
                                            }
                                        >
                                            <EditContainerMob
                                                labelColor={
                                                    moment(
                                                        listData.fromDate
                                                    ).isAfter(todayDate) ||
                                                    checkProxyActive() ||
                                                    checkImpersonationActive()
                                                        ? 'white'
                                                        : '#1010eb'
                                                }
                                            >
                                                <a
                                                    style={{ display: 'flex' }}
                                                    onClick={() =>
                                                        openInitiateProxy(
                                                            listData
                                                        )
                                                    }
                                                >
                                                    <StyledImageMob
                                                        src={
                                                            moment(
                                                                listData.fromDate
                                                            ).isAfter(
                                                                todayDate
                                                            ) ||
                                                            checkProxyActive() ||
                                                            checkImpersonationActive()
                                                                ? DisabledInitiate
                                                                : InitiatePlay
                                                        }
                                                        cursor={
                                                            !checkProxyActive() &&
                                                            !checkImpersonationActive()
                                                                ? 'pointer'
                                                                : 'default'
                                                        }
                                                        width="auto"
                                                        height="auto"
                                                    />
                                                    <ButtonLabelMob
                                                        labelColor={
                                                            moment(
                                                                listData.fromDate
                                                            ).isAfter(
                                                                todayDate
                                                            ) ||
                                                            checkProxyActive() ||
                                                            checkImpersonationActive()
                                                                ? 'white'
                                                                : '#1010eb'
                                                        }
                                                        cursor={
                                                            !checkProxyActive() &&
                                                            !checkImpersonationActive()
                                                                ? 'pointer'
                                                                : 'default'
                                                        }
                                                    >
                                                        {t('proxies.initiate')}
                                                    </ButtonLabelMob>
                                                </a>
                                            </EditContainerMob>
                                        </EditIconContainerMob>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        lg={12}
                                        xl={12}
                                        mobile={12}
                                    >
                                        {dist && dist.length > 0 && (
                                            <DistContainer>
                                                {t('proxies.district')}
                                            </DistContainer>
                                        )}
                                        {dist &&
                                            dist.length > 0 &&
                                            dist.map((address, index) => {
                                                return (
                                                    <DistrictContainer
                                                        key={index}
                                                    >
                                                        {address}
                                                    </DistrictContainer>
                                                );
                                            })}
                                    </Grid>
                                </Grid>
                            </ProxyListContainerWrapper>
                        );
                })}
            {showInitiateProxy && (
                <Popup
                    contentWidth={'50%'}
                    width={'50%'}
                    webWidth={'50%'}
                    handleClose={closeInitiateProxy}
                    margin={'40% 0 0 0'}
                    id={'proxyBanner-userProxyList-popup'}
                >
                    <PopupContainer>
                        <InitiateProxy
                            addProxyPopup={initiateProxy}
                            handleClose={closeInitiateProxy}
                            // isFromAccount={props.isFromAccount}
                            proxyData={proxyData}
                            onHide={props.onHide}
                        />
                    </PopupContainer>
                </Popup>
            )}
        </UserProxyListContainer>
    );
};

export default UserProxyList;
